import React from "react";
import {IRepo, ISecret, ITeam} from "./Interfaces/IGithub";

export type GithubDataContextType = {
    repos: IRepo[];
    secrets: ISecret[];
    teams: ITeam[];
    refreshData: () => void;
    org: string;
    slug: string;
    costCenter: string;
    loading: boolean; // ADDED
};

const defaultGithubDataContext: GithubDataContextType = {
    repos: [],
    secrets: [],
    teams: [],
    refreshData: () => {},
    org: "",
    slug: "",
    costCenter: "",
    loading: false
};

export const GithubDataContext = React.createContext<GithubDataContextType>(defaultGithubDataContext);
